import React from "react";
import { useNavigate } from "react-router-dom";
import threeDotsImage from "../../../assets/images/Ic_more.png";
import positionIcon from "../../../assets/images/Ic_work position.png";
import industryIcon from "../../../assets/images/Ic_work company.png";
import locIcon from "../../../assets/images/Ic_location1.png";
import salaryIcon from "../../../assets/images/Ic_amount.png";
import { BlobImage } from "../../../utils/blobImage";

const CandidateCard = ({
    candidate,
    tabType,
    isMenuOpen,
    onMenuToggle,
    // onMoveClick,
    onRemoveClick,
    preserveState
}) => {
    const navigate = useNavigate();

    const handleNavigate = () => {
        if (isMenuOpen) return;

        sessionStorage.setItem(
            "curatedShortlistedState",
            JSON.stringify(preserveState)
        );

        sessionStorage.setItem("restoreCuratedShortlisted", "true");

        navigate(
            `/client/candidate-information?candidateId=${candidate.candidateId}`
        );
    };


    return (
        <div className="candidate-grid-item">
            <div
                className="searchcandidate-result-card searchcandidate-grid-card"
                onClick={handleNavigate}
                style={{ cursor: "pointer", position: "relative" }}
            >
                {candidate.status && (
                    <div className="candidate-status-wrapper">
                        {candidate.status === 'VALIDATED' ? (
                            <i
                                className="fas fa-check-circle candidate-status-icon validated"
                            />
                        ) : (
                            <i
                                className="fas fa-clock candidate-status-icon in-progress"
                            />
                        )}

                        <span className="candidate-status-tooltip">
                            {candidate.status === 'VALIDATED'
                                ? 'Verified'
                                : 'Verification In Progress'}
                        </span>
                    </div>
                )}
                {/* HEADER */}
                <div className="searchcandidate-card-header d-flex justify-content-between align-items-start">
                    <div className="d-flex align-items-center">
                        <div>
                            <BlobImage imageUrl={candidate.personImage} />
                        </div>

                        <div className="searchcandidate-card-header-text">
                            <p className="searchcandidate-name truncate-text">
                                <span>{candidate.salutation ? `${candidate.salutation} ` : ""}</span>
                                <span>{candidate.firstName} </span>
                                <span>{candidate.lastName}</span>
                            </p>
                            <p>Experience: {candidate.experience}</p>
                        </div>
                    </div>

                    {/* {candidate.shortlistStatus && (
            <p
              className={`searchcandidate-shortlist-status ${candidate.shortlistStatus.toLowerCase()}`}
            >
              {candidate.shortlistStatus}
            </p>
          )} */}

                    {/* THREE DOT MENU */}
                    {tabType === "SHORTLISTED" && (
                        <div
                            className="candidate-card-menu"
                            onClick={onMenuToggle}
                            style={{ position: "relative" }}
                        >
                            <img src={threeDotsImage} alt="More" />

                            {isMenuOpen && (
                                <div
                                    className="candidate-card-dropdown"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    {/* <div
      className="candidate-card-dropdown-item"
      onClick={() => onMoveClick(candidate)}
    >
      Move To Another Folder
    </div>
    <div className="candidate-remove-card-divider" /> */}

                                    <div
                                        className="candidate-card-dropdown-item remove"
                                        onClick={() => onRemoveClick(candidate)}
                                    >
                                        Remove Candidate
                                    </div>
                                </div>
                            )}

                        </div>
                    )} &nbsp;
                </div>

                {/* CONTENT */}
                <div className="searchcandidate-card-content mt-3">
                    <div className="searchcandidate-info-item">
                        <img src={positionIcon} alt="Position" className="searchcandidate-info-icon" />
                        <p className="searchcandidate-info-item-p truncate-text">
                            {candidate.position}
                        </p>
                    </div>

                    <div className="searchcandidate-info-item">
                        <img src={industryIcon} alt="Company" className="searchcandidate-info-icon" />
                        <p className="searchcandidate-info-item-p truncate-text">
                            {candidate.company}
                        </p>
                    </div>

                    <div className="searchcandidate-info-item">
                        <img src={industryIcon} alt="Industry" className="searchcandidate-info-icon" />
                        <p className="searchcandidate-info-item-p truncate-text">
                            {candidate.industry}
                        </p>
                    </div>

                    <div className="searchcandidate-info-item">
                        <img src={locIcon} alt="Location" className="searchcandidate-info-icon" />
                        <p className="searchcandidate-info-item-p truncate-text">
                            {candidate.location}
                        </p>
                    </div>

                    <div className="searchcandidate-info-item">
                        <img src={salaryIcon} alt="Salary" className="searchcandidate-info-icon" />
                        <p className="searchcandidate-info-item-p truncate-text">
                            {candidate.salary}
                        </p>
                    </div>
                </div>

                <div className="candidate-view-profile-overlay">
                    View Profile
                    <i className="fas fa-arrow-right" style={{ marginLeft: 10 }} />
                </div>
            </div>
        </div>
    );
};

export default CandidateCard;